export const MODE = {
  WIKI: 'wiki',
  GANTT: 'gantt',
}

export const VIEW_MODE = {
  VIEW: 'view',
  FORM: 'form',
}

export const GANTT_STATUS = {
  EMPTY: 'empty',
  PUBLIC: 'public',
  PROTECTED: 'protected',
}
